import { AbsoluteFill, Img, spring, staticFile, useCurrentFrame, useVideoConfig } from "remotion";
import { preloadImage } from "@remotion/preload";
import './assets/css/Especs.css'
import { useEffect } from "react";

interface SeccionInterface {
	plan: {
		label: string,
		value: string
	}[],
}

export const ResumenSection = ({ plan }: SeccionInterface) => {
	const frame = useCurrentFrame();
	const { durationInFrames, fps } = useVideoConfig();
	useEffect(() => {
		preloadImage(staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/01_FONDO.jpg"));
		preloadImage(staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/claro-white.svg"));
	}, []);
	const scaleSection = spring({
		fps,
		frame,
		config: { damping: 400, stiffness: 400 },
		from: 1,
		to: 2,
		delay: (durationInFrames - 8)
	});
	const blurSection = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 10,
		delay: (durationInFrames - 8)
	});

	const scalePhone = spring({
		fps,
		frame: frame * 3,
		config: { damping: 1, stiffness: 1 },
		from: 0,
		to: 1,
		delay: 0
	});

	// ? LABEL 1

	const label1Rotate = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: -30,
		to: 0,
		delay: 0
	});
	const label1TranslateX = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: -30,
		to: 0,
		delay: 0
	});
	const label1TranslateY = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 30,
		to: 0,
		delay: 0
	});
	const label1Scale = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 0
	});

	const label1TextOpacity = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 15
	});

	const value1Opacity = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 18
	});
	const value1Transform = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: -10,
		to: 0,
		delay: 18
	});
	const value1Scale = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0.8,
		to: 1,
		delay: 18
	});

	// ? LABEL 2

	const label2Rotate = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: -30,
		to: 0,
		delay: 16
	});
	const label2TranslateX = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: -30,
		to: 0,
		delay: 16
	});
	const label2TranslateY = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 30,
		to: 0,
		delay: 16
	});
	const label2Scale = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 16
	});
	const label2TextOpacity = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 30
	});

	const value2Opacity = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 34
	});
	const value2Transform = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: -10,
		to: 0,
		delay: 34
	});
	const value2Scale = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0.8,
		to: 1,
		delay: 34
	});

	// ? LABEL 3

	const label3Rotate = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: -30,
		to: 0,
		delay: 46
	});
	const label3TranslateX = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: -30,
		to: 0,
		delay: 46
	});
	const label3TranslateY = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 30,
		to: 0,
		delay: 46
	});
	const label3Scale = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 46
	});
	const label3TextOpacity = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 60
	});

	const value3Opacity = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 64
	});
	const value3Transform = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: -10,
		to: 0,
		delay: 64
	});
	const value3Scale = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0.8,
		to: 1,
		delay: 64
	});

	// ? NEON

	const neonOpacity = spring({
		fps,
		frame: frame * 2,
		config: { damping: 1, stiffness: 1 },
		from: 0,
		to: 1,
		delay: 90
	});
	const neonTranslate = spring({
		fps,
		frame: frame,
		config: { damping: 300, stiffness: 100 },
		from: -30,
		to: 0,
		delay: 54
	});
	const neonWidth = spring({
		fps,
		frame: frame,
		config: { damping: 100, stiffness: 100 },
		from: 300,
		to: 610,
		delay: 54
	});
	const neonHeight = spring({
		fps,
		frame: frame,
		config: { damping: 100, stiffness: 100 },
		from: 300,
		to: 557,
		delay: 54
	});

	let startingPoint = 0;
	return (
		<AbsoluteFill style={{
			filter: (blurSection > 0) ? `blur(${blurSection}px)` : '',
			transform: `scale(${scaleSection})`
		}}>
			<AbsoluteFill style={{
				backgroundColor: "#B21F1D"
			}}>
				<Img className="fondo" src={staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/10_FONDO.jpg")} style={{
					position: "absolute"
				}} />
			</AbsoluteFill>
			<AbsoluteFill>
				<div className="phone" style={{
					position: "absolute",
					top: "50%",
					left: 130,
					transform: `translateY(-50%) scale(${scalePhone})`,
				}}>
					<Img className="fondo" src={staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/03_PHONE-2.png")} style={{
						maxWidth: "100%",
						width: 500
					}}/>
				</div>
				<div className="resumen" style={{
					position: "absolute",
					right: 250,
					top: "50%",
					zIndex: 1,
					transform: "translateY(-50%)",
				}}>
					{plan?.map((value, index) => {
						startingPoint += 16;
						const currentIndex = index + 1;

						const currentLabelRotate = spring({
							fps,
							frame,
							config: { damping: 100, stiffness: 100 },
							from: -30,
							to: 0,
							delay: startingPoint
						});
						const currentLabelTranslateX = spring({
							fps,
							frame,
							config: { damping: 100, stiffness: 100 },
							from: -30,
							to: 0,
							delay: startingPoint
						});
						const currentLabelTranslateY = spring({
							fps,
							frame,
							config: { damping: 100, stiffness: 100 },
							from: 30,
							to: 0,
							delay: startingPoint
						});
						const currentLabelScale = spring({
							fps,
							frame,
							config: { damping: 100, stiffness: 100 },
							from: 0,
							to: 1,
							delay: startingPoint
						});

						const currentLabelTextOpacity = spring({
							fps,
							frame,
							config: { damping: 100, stiffness: 100 },
							from: 0,
							to: 1,
							delay: startingPoint + 15
						});

						const currentValueOpacity = spring({
							fps,
							frame,
							config: { damping: 100, stiffness: 100 },
							from: 0,
							to: 1,
							delay: startingPoint + 18
						});
						const currentValueTransform = spring({
							fps,
							frame,
							config: { damping: 100, stiffness: 100 },
							from: -10,
							to: 0,
							delay: startingPoint + 18
						});
						const currentValueScale = spring({
							fps,
							frame,
							config: { damping: 100, stiffness: 100 },
							from: 0.8,
							to: 1,
							delay: startingPoint + 18
						});

						return (
							<div className="item" key={value.label}>
								<div className="label" style={{
									transformOrigin: "left",
									transform: `translate(${currentLabelTranslateX}px, ${currentLabelTranslateY}px) scale(${currentLabelScale}) rotate(${currentLabelRotate}deg)`
								}}><span style={{
									opacity: currentLabelTextOpacity
								}}>{value.label}</span></div>
								<div className="value" style={{
									opacity: currentValueOpacity,
									transformOrigin: "left",
									transform: `scale(${currentValueScale}) translateX(${currentValueTransform}px)`
								}}>{value.value}</div>
							</div>
						);
					})}
					<div className="cuadro" style={{
						position: "absolute",
						fontWeight: "bold",
						left: 265,
						top: "50%",
						zIndex: -1,
						fontSize: 47,
						color: "#fff",
						display: "flex",
						borderRadius: 58,
						alignItems: "center",
						padding: "0.5rem 1rem",
						border: "4px solid #fff",
						justifyContent: "center",
						textTransform: "uppercase",
						width: neonWidth,
						height: neonHeight,
						opacity: neonOpacity,
						transform: `translateY(-50%) translateX(${neonTranslate}px)`,
						boxShadow: "0 0 0.5rem #fff, inset 0 0 0.5rem #fff, 0 0 2rem #FF0000, inset 0 0 2rem #FF0000, 0 0 4rem #FF0000, inset 0 0 4rem #FF0000",
					}}>
						<div className="circle" style={{
							position: "absolute",
							top: -60,
							right: -60,
						}}>
							<Img className="fondo" src={staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/circle-white-lines.svg")} style={{
								display: "block",
								width: 140
							}} />
						</div>
					</div>
				</div>
			</AbsoluteFill>
		</AbsoluteFill>
	);
};